<template>
  <div class="l-contentmain contentmain">
    <page-nav-bar
      v-if="company"
      :is-sticky="true"
      :back-button="true"
      :has-actions="canRemove">
      <template slot="breadcrumb">
        <h1 class="page-header-breadcrumb-item is-uppercase">
          <router-link :to="{ name: 'RelationsList'}">
            Partenaires
          </router-link>
        </h1>
        <div class="page-header-breadcrumb-separator"></div>
        <div
          class="page-header-breadcrumb-item"
          v-if="company && company.name">
          <span class="has-text-weight-normal has-text-grey-dark is-uppercase">{{ company.name }}</span>
        </div>
      </template>
      <a
        @click="removeRelation"
        class="dropdown-item has-background-danger has-text-white"
        slot="dropdown-content"
        v-if="canRemove">
        <span class="icon is-medium"><i class="fas fa-trash-alt"></i></span>
        <span class="is-margin-left-xsmall">Supprimer le partenaire</span>
      </a>
    </page-nav-bar>
    <spinner-round
      :is-loading="loading"
      v-if="loading"></spinner-round>
    <page-content
      v-else-if="company && !loading"
      :has-left-col-small="true"
      :has-left-col-small-size-fixed="false"
      :has-sticky-col-left="true">
      <template slot="left-col-small">
        <div class="has-background-white is-border">
          <div class="is-padding-top is-padding-left is-padding-right is-padding-bottom-small has-text-centered">
            <figure class="image is-128x128 is-margin-auto has-vadPicto has-picto--top2Right">
              <div class="is-border is-border--circle is-clipped">
                <div
                  v-if="company.picture"
                  class="has-text-white is-clipped is-relative has-background-light--darken2"
                  style="width: 126px; height: 126px; line-height: 126px;">
                  <img :src="company.picture|avatarBig">
                </div>
                <div
                  v-else
                  class="has-text-white is-size-1 is-clipped is-relative has-background-light--darken2"
                  style="width: 126px; height: 126px; line-height: 126px;">
                  {{ company.name[0] | cap }}{{ company.name[1] | cap }}
                </div>
              </div>
            </figure>
            <div
              v-if="company && company.name"
              class="title is-3 is-margin-top-xsmall is-marginless-bottom">
              <b>{{ company.name }}</b>
            </div>
          </div>
          <div class="is-padding is-border-top">
            <div class="columns is-multiline">
              <div class="column is-12 is-paddingless-bottom">
                <div class="columns is-gapless">
                  <div class="column is-size-6 is-narrow is-w80p is-margin-right-xsmall">
                    <b>Référent :</b>
                  </div>
                  <div class="column is-size-6 is-break-word">
                    <router-link
                      :to="{name: 'UserVue', params: {id: company.first_admin.pk}}"
                      class="fullLink is-hover-underline">
                      <span class="is-uppercase">{{ company.first_admin.last_name }}</span>
                      {{ company.first_admin.first_name }}
                    </router-link>
                  </div>
                </div>
              </div>
              <div class="column is-12 is-paddingless-bottom">
                <div class="columns is-gapless">
                  <div class="column is-size-6 is-narrow is-w80p is-margin-right-xsmall">
                    <b>Mail :</b>
                  </div>
                  <div class="column is-size-6 is-break-word">
                    <a
                      :href="`mailto:${company.first_admin.email}`"
                      class="is-hover-underline">{{ company.first_admin.email }}</a>
                  </div>
                </div>
              </div>
              <div class="column is-12">
                <div class="columns is-gapless">
                  <div class="column is-size-6 is-narrow is-w80p is-margin-right-xsmall">
                    <b>Téléphone :</b>
                  </div>
                  <div class="column is-size-6">
                    <phone-number :phone="company.first_admin.phone"></phone-number>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="currentUser.account.external_connection && currentUser.account.external_connection.length"
            class="is-border-top is-padding-left">
            <div class="columns is-multiline">
              <div class="column is-12">
                <div class="columns is-gapless">
                  <div class="column is-3 is-size-6 is-flex-between is-border-right is-padding-top-small is-padding-bottom-small">
                    <b>ID Externe :</b>
                    <span></span>
                  </div>
                  <div
                    v-if="updateMode"
                    class="column is-6 is-size-6 is-border-right is-fullheight is-flex-center">
                    <div class="control">
                      <v-input
                        id="external_id"
                        name="external_id"
                        :classes-input="'custom-padding'"
                        @input="val => company.external_id = val"
                        :model="company.external_id"
                        class=""
                        :errors-bag="errors"
                        data-vv-value-path="val"
                        :number="false"
                        input-type="string"
                        data-vv-as="">
                      </v-input>
                    </div>
                  </div>
                  <div
                    v-else
                    class="column is-6 is-size-6 is-border-right is-flex-center">
                    <span v-if="!company.external_id">—</span>
                    <span v-else>{{ company.external_id }}</span>
                  </div>
                  <div class="column is-3 is-narrow is-self-stretched">
                    <button
                      v-if="!updateMode"
                      @click="updateMode = true"
                      class="button is-small is-white is-transform-none is-padding-left-small is-padding-right-small is-height-full is-radiusless is-fullwidth">
                      <span class="">Modifier</span>
                    </button>
                    <button
                      v-else
                      @click="patchExternalId"
                      class="button is-small is-success is-transform-none is-padding-right-small is-padding-left-small is-height-full is-radiusless is-fullwidth">
                      <span class="">Enregistrer</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="is-padding is-border-top">
            <div class="columns is-multiline">
              <div class="column is-12 is-paddingless-bottom">
                <div class="columns is-gapless">
                  <div class="column is-size-6 is-narrow is-w80p is-margin-right-xsmall">
                    <b>Adresse :</b>
                  </div>
                  <div class="column is-size-6">
                    <a
                      @click="openGoogleMap(company.address)"
                      v-if="company.address"
                      class="is-hover-underline">
                      <div v-if="company.address.line1">{{ company.address.line1 }}</div>
                      <div v-if="company.address.line2">{{ company.address.line2 }}</div>
                      <div>
                        <span v-if="company.address.zip_code">{{ company.address.zip_code }}&nbsp;</span>
                        <span v-if="company.address.city">{{ company.address.city }}&nbsp;</span>
                        <i v-if="company.address.country && company.address.country.trim().toLowerCase() !== 'france'">{{ company.address.country }}&nbsp;</i>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              <div class="column is-12 is-paddingless-bottom">
                <div class="columns is-gapless">
                  <div class="column is-size-6 is-narrow is-w80p is-margin-right-xsmall">
                    <b>Mail :</b>
                  </div>
                  <div class="column is-size-6 is-break-word">
                    <a
                      :href="`mailto:${company.email}`"
                      class="is-hover-underline">{{ company.email }}</a>
                  </div>
                </div>
              </div>
              <div class="column is-12">
                <div class="columns is-gapless">
                  <div class="column is-size-6 is-narrow is-w80p is-margin-right-xsmall">
                    <b>Téléphone :</b>
                  </div>
                  <div class="column is-size-6">
                    <phone-number :phone="company.phone"></phone-number>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="is-border-top is-border--dashed">
            <div class="columns is-multiline is-gapless">
              <div
                @click="changeView('CompanyAccesses')"
                class="column is-6 is-border-bottom is-border-right is-border--dashed columns is-column is-space-between is-padding-top-small is-padding-bottom-small is-padding-left is-padding-right">
                <div class="has-text-grey is-size-6">
                  Mandats en cours
                </div>
                <div> {{ companyAccesses.length }}</div>
              </div>
              <div
                @click="changeView('CompanyOptions')"
                class="column is-6 is-border-bottom is-border--dashed columns is-column is-space-between is-padding-top-small is-padding-bottom-small is-padding-left is-padding-right">
                <div class="has-text-grey is-size-6">
                  Options
                </div>
                <div> {{ runningOption.length }}</div>
              </div>
              <div
                @click="changeView('CompanyReservations')"
                class="column is-6 is-border-bottom is-border-right is-border--dashed columns is-column is-space-between is-padding-top-small is-padding-bottom-small is-padding-left is-padding-right">
                <div class="has-text-grey is-size-6">
                  Pré-Réservation en cours
                </div>
                <div> {{ pendingReservation.length }}</div>
              </div>
              <div
                @click="changeView('CompanyReservations')"
                class="column is-6 is-border-bottom is-border-right is-border--dashed columns is-column is-space-between is-padding-top-small is-padding-bottom-small is-padding-left is-padding-right">
                <div class="has-text-grey is-size-6">
                  Ventes
                </div>
                <div> {{ soldReservation.length }}</div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <div class="has-background-white is-border">
        <tabs
          :links="companyTabLinks"
          :level="1"
          class="is-border-bottom">
        </tabs>
        <router-view
          :company="company"
          :parent-allotments="companyAllotments"
          :parent-accesses="companyAccesses"
          :channel="channel"
          :company-options="companyOptions"
          :company-reservations="companyReservations"
          @afterUpdateAccess="afterUpdateAccess"
          @afterCreatedAccess="getAccesses"
          @afterDeleteAccess="getAccesses"></router-view>
      </div>
    </page-content>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
// import { concat } from 'lodash'

export default {
  name: 'CompanyVue',
  data () {
    return {
      updateMode: false,
      companyAllotments: [],
      companyAccesses: [],
      companyMandats: [],
      companyReservations: [],
      companyOptions: [],
      company: null,
      loading: false,
      channel: null,
      relationsLink: null
    }
  },
  computed: {
    ...mapGetters(['isAdmin', 'isPromoteur', 'isManager', 'statsEnabled', 'accountPk']),
    ...mapState(['currentUser']),
    canRemove () {
      return this.isAdmin && this.currentUser.account.pk !== this.companyPk
    },
    pendingReservation () {
      return this.companyReservations.filter(x => x.status === 'pre_reserved')
    },
    soldReservation () {
      return this.companyReservations.filter(x => x.status === 'sold' || x.status === 'reserved')
    },
    companyPk () {
      return this.$route.params.id
    },
    runningOption () {
      return this.companyOptions.filter(x => x.status === 'approved' || x.status === 'waiting_list')
    },
    companyTabLinks () {
      const tabs = [
        { link: 'CompanyAccesses', label: 'Mandat' },
        { link: 'CompanyOptions', label: 'Options' },
        { link: 'CompanyReservations', label: 'Ventes' }
      ]
      if (this.statsEnabled) {
        tabs.unshift({ link: 'CompanyStats', label: 'Activité' })
      }
      return tabs
    },
    companyView () {
      return this.$route.name
    }
  },
  watch: {
    companyPk (to, from) {
      if (to && to !== from && !this.isParent) {
        this.initView()
      }
    }
  },
  created () {
    if (!(this.companyView in this.companyTabLinks.map(x => x.link))) {
      if (this.statsEnabled) {
        this.$router.replace({ name: 'CompanyStats' })
      } else {
        this.$router.replace({ name: 'CompanyAccesses' })
      }
    }
    this.initView()
  },
  methods: {
    async patchExternalId () {
      this.loading = true
      try {
        await this.$api.patch(this.$resources.ACCOUNT, this.companyPk, { external_id: this.company.external_id })
        this.$toasted.global.success('L\'ID externe à été mis à jour.')
      } catch (e) {
        this.$toasted.global.danger('Erreur lors de la mise à jour de l\'ID externe.')
      }
      this.loading = false
      this.updateMode = false
    },
    async initView () {
      this.getCompany()
      this.getOptions()
      this.getAccesses()
      this.getReservations()
      this.getAllotments()
    },
    changeView (link) {
      if (this.companyView !== link) {
        this.$router.replace({ name: link })
      }
    },
    afterUpdateAccess () {
      this.getAccesses()
      this.getAllotments()
    },
    async getCompany () {
      this.loading = true
      try {
        let { data } = await this.$api.getOne(this.$resources.ACCOUNT, this.companyPk)
        this.company = data
        this.loading = false
      } catch (err) {
        this.loading = false
      }
    },
    async getOptions () {
      let params = { account: this.companyPk }
      try {
        let { data } = await this.$api.get(this.$resources.OPTION, params)
        this.companyOptions = data.items
      } catch (e) {
        console.log(e)
      }
    },
    async getAccesses () {
      let params = { account: this.companyPk }
      let mandatsParams = { account: this.companyPk }
      try {
        let { data } = await this.$api.get(this.$resources.ACCESS, params)
        this.companyAccesses = data.items
      } catch (e) {
        console.log(e)
      }
      try {
        let { data } = await this.$api.get(this.$resources.MANDAT, mandatsParams)
        this.companyMandats = data.items
      } catch (e) {
        console.log(e)
      }
      this.companyAccesses = this.companyAccesses.concat(this.companyMandats)
      this.checkCanal()
    },
    async getAllotments (page = 1) {
      let params = { user: this.companyPk }
      try {
        let { data } = await this.$api.get(this.$resources.ALLOTMENT_ALL, params)
        this.companyAllotments = data.all_allotment
      } catch (e) {
        console.log(e)
      }
    },
    async getReservations () {
      let params = { account: this.companyPk }
      try {
        let { data } = await this.$api.get(this.$resources.RESERVATION, params)
        this.companyReservations = data.items
      } catch (e) {
        console.log(e)
      }
    },
    async removeRelation () {
      let value = await this.$swal({
        title: 'Suppression',
        text: 'Souhaitez-vous vraiment retirer cette société de vos relations ?',
        confirmButtonText: 'Supprimer',
        focusConfirm: false
      })
      if (value.dismiss) return false // ON ne supprimme pas l'utilisateur
      if (value) {
        try {
          let params = {
            account_two: this.companyPk,
            promoteur_pk: this.accountPk
          }
          let { data } = await this.$api.get(this.$resources.RELATIONS_LINK, params)
          let relationToDelete = data.items[0].pk
          await this.$api.delete(this.$resources.RELATIONS_LINK, relationToDelete)
          await this.$router.push({ name: 'RelationsList' })
          // const dataToDeleted = data.items.filter(x => {
          //   if (x.account_two !== null && x.account_two === this.companyPk) {
          //     return x.pk
          //   } else if (x.invitation !== null && x.invitation.account_two === this.companyPk) {

          //   }
          // })
          // for (let d of dataToDeleted) {
          //   await this.$api.delete(this.$resources.RELATIONS_LINK, d.pk)
          // }
          // let { data } = await this.$api.get(this.$resources.ACCOUNT_RELATION, { account_two: this.companyPk })
          // await this.$api.delete(this.$resources.ACCOUNT_RELATION, data.items[0].pk)
        } catch (e) {
          console.log(e)
          this.$toasted.global.danger('Impossible de supprimer cette relation')
        }
      }
    },
    openGoogleMap (address) {
      let fullAddress
      if (address.line1) {
        let line1Convert = address.line1.split(' ')
        let convertedLine1 = ''
        line1Convert.forEach(element => {
          convertedLine1 += element + '+'
        })
        fullAddress = convertedLine1 + address.zip_code + '+' + address.city
      }
      if (address.line2) {
        let line2Convert = address.line2.split(' ')
        let convertedLine2 = ''
        line2Convert.forEach(element => {
          convertedLine2 += element + '+'
        })
        fullAddress = convertedLine2 + address.zip_code + '+' + address.city
      }
      let url = 'https://www.google.com/maps/search/?api=1&query=' + fullAddress
      window.open(url)
    },
    async checkCanal (data) {
      this.companyAccesses.forEach(access => {
        if (Object.prototype.hasOwnProperty.call(access, 'sales_channel')) {
          this.channel = access.sales_channel
        }
      })
    }
  }
}
</script>
